<template>
    <div class="all">
      <header >
        <vs-input class="search" v-model="value" placeholder="Name" />
      </header>
      <vs-sidebar
        absolute
        v-model="active"
        open
        :notShadow="true"
        >
        <template #logo>
          <div class="title">表单打印</div>
        </template>
        <vs-sidebar-item id="home">
          <template #icon>
            <i class='bx bx-home'></i>
          </template>
          研究生院
        </vs-sidebar-item>
        <!-- <vs-sidebar-item id="market">
          <template #icon>
            <i class='bx bx-grid-alt'></i>
          </template>
          Market Overview
        </vs-sidebar-item>
        <vs-sidebar-item id="Music">
          <template #icon>
            <i class='bx bxs-music'></i>
          </template>
          Music
        </vs-sidebar-item>
        <vs-sidebar-item id="donate">
          <template #icon>
            <i class='bx bxs-donate-heart' ></i>
          </template>
          Donate
        </vs-sidebar-item>
        <vs-sidebar-item id="drink">
          <template #icon>
            <i class='bx bx-drink'></i>
          </template>
          Drink
        </vs-sidebar-item>
        <vs-sidebar-item id="shopping">
          <template #icon>
            <i class='bx bxs-shopping-bags'></i>
          </template>
          Shopping
        </vs-sidebar-item>
        <vs-sidebar-item id="chat">
          <template #icon>
            <i class='bx bx-chat' ></i>
          </template>
          Chat
        </vs-sidebar-item> -->
      </vs-sidebar>
      <main class="page">
        <vs-card-group>
          <vs-card :key="index" v-for="(card,index) in list" >
            <template #title>
              <h3>{{ card.name }}</h3>
            </template>
            <!-- <template #img>
              <img :src="`/foto${card}.png`" alt="">
            </template> -->
            <template #text>
              <p>
                {{ card.description }}
              </p>
            </template>
            <template #buttons>
              <vs-button-group>
              <vs-button
                :active="active == 0"
                @click="handleClick(card.id,card.name)"
              >
                <i class="bx bx-fullscreen"></i> 预览
              </vs-button>

              <vs-button
                success
                flat
                :active="active == 1"
                @click="active = 1"
              >
                下载
              </vs-button>
              </vs-button-group>
            </template>

            <template #interactions>
              <vs-button danger icon>
                <i class='bx bx-heart'></i>
              </vs-button>
              <vs-button class="btn-chat" shadow primary>
                <i class='bx bx-chat' ></i>
                <span class="span">
                  54
                </span>
              </vs-button>
            </template>
          </vs-card>
        </vs-card-group>
        <fullscreenVue ref="fullscreen"></fullscreenVue>
      </main>
    </div>
  
</template>

<script>

 import { getView } from '@/api/data/view'
import fullscreenVue from './FullScreen'
export default {
  data(){
    return {
      active: 'home',
      value:'',
      list:[],
    }
  },
  components:{
    fullscreenVue
  },
  async mounted(){
    await this.GetView();
  },
  methods:{
    async GetView(){
      let res= await getView();
      console.log(res);
      this.list = res.items;
    },
    handleClick(id,name){
      console.log(id,name)

       this.$refs["fullscreen"].dialog(id,name);
       // this.$router.push({path:'YJSProofOfReading',query: {id:id}})
    }
  }
}
</script>

<style lang="scss" scoped>
// ::v-deep .vs-sidebar-content{
//   box-shadow: none !important;
// }
  header{
    display: flex;
    height: 68.39px;
    background: white;
    border-radius: 0 0 30px 0;
    justify-content: flex-end;
    padding:0 20px;
    align-items: center;
  }
  .title{
    font-family: 'KaiTi';
    font-size: 20px;

  }
  .search{
    cursor: text;
    width: 15rem;
    color: var(--vs-theme-color);
    display: inline-block;
    border-radius: 2rem;
    font-size: .85rem;
    line-height: 2rem;
    height:40px;
    outline: none;
    transition: all .2s ease;
    background: rgba(0,0,0,.05);
    background-size: 1rem;
    display: block;
    border-radius: 0;
    border: 0;
    padding: 4px 4px 4px 20px;
    opacity: 1;
    border-radius: 14px 5px 14px 14px;
  }
  .all{
    background:white;
    width: 100%;
    height: 100vh;
  }
  .page{

    margin-left: 260px;
    padding-left: 0!important;
    background-color: #f4f7f8!important;

    display: block;
    position: relative;
    margin-bottom: 0;
    transition: all .25s ease;
    width: calc(100% - 260px);
    max-height: calc(100vh - 68.38px);
    height: calc(100vh - 68.38px);

    border-radius: 14px 0 0 0;

  }

  @media (max-width: 1000px){
    .page {
        padding-left: 0;
        margin-left: 0!important;
        width: 100%;

      
    }
  }

</style>